export const INIT_APP = "INIT_APP";
export const APP_READY = "APP_READY";
export const AUTHENTICATED = "AUTHENTICATED";
export const NOT_AUTHENTICATED = "NOT_AUTHENTICATED";
export const LOGOUT = "LOGOUT";
export const CREATE_ALERT = "CREATE_ALERT";
export const DELETE_ALERT = "DELETE_ALERT";

export const SET_AUTH_TYPE = "SET_AUTH_TYPE";

// TODO: Need to make these descriptive
export const UPDATE_UNREAD = "UPDATE_UNREAD";

export const SET_ROLES = "SET_ROLES";

export const SET_MANAGED_ROLES = "SET_MANAGED_ROLES";

export const SET_USERNAME = "SET_USERNAME";

export const SET_LEGACY_CHECKBOXES = "SET_LEGACY_CHECKBOXES";

export const SET_CHECKED_BOXES = "SET_CHECKED_BOXES";

export const ADD_CHECKED_BOX = "ADD_CHECKED_BOX";

export const REMOVE_CHECKED_BOX = "REMOVE_CHECKED_BOX";

export const FORM_FULL_WIDTH = "FORM_FULL_WIDTH";
